import { render, staticRenderFns } from "./BajaMri.vue?vue&type=template&id=38561a45&"
import script from "./BajaMri.vue?vue&type=script&lang=js&"
export * from "./BajaMri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports